import BrowserInfoService from 'app/services/browserInfo.service';

const NS = 'BrowserWarningCtrl';

export default function BrowserWarningCtrl() {
  "ngInject";

  var vm = this;
  vm.browserInfo = BrowserInfoService.getBrowserInfo();
}
